import { makeStyles } from '@mui/styles'
const useStylesAddUserForSuscriber = makeStyles(() => ({
  mainBox: {
    width: '100%'
  },
  box1: {
    marginLeft: '5%',
    width: '90%',
    marginTop: '2%'
  },
  typographyAddUser: {
    mt: 2,
    mb: 1,
    fontWeight: 'bold',
    color: '#32332E',
    fontSize: 18
  },
  typographyInstructions: {
    mt: 2,
    mb: 1,
    fontSize: 15
  },
  typographyFields: {
    mt: 2,
    mb: 1,
    fontSize: 14,
    marginTop: '2%'
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    pt: 2,
    marginLeft: '5%',
    width: '90%',
    position: 'absolute',
    bottom: 20
  },
  createButton: {
    width: 90,
    height: 35,
    backgroundColor: '#1C846F',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    borderRadius: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  typographyCreateButton: {
    color: '#FFFFFF',
    cursor: 'pointer',
    fontSize: 16
  },
  cancelButton: {
    width: 90,
    height: 35,
    marginLeft: 5,
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    borderRadius: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  typographyCancelButton: {
    color: '#262626',
    cursor: 'pointer',
    fontSize: 16,
    '&:hover': {
      color: '#1BF57F'
    }
  }
}))

export default useStylesAddUserForSuscriber
